import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TaskCounts, TaskCountType } from '@lyceo/shared/task-count/util';

export const TaskCountActions = createActionGroup({
  source: 'Task Count',
  events: {
    'Get Task Counts': emptyProps(),
    'Get Task Counts Success': props<{ taskCounts: TaskCounts }>(),
    'Get Task Counts Failure': props<{ error: Error }>(),
    'Task Count Clicked': props<{ taskCountType: TaskCountType }>(),
  },
});
